import { render, staticRenderFns } from "./ViTeacherAcademicManagementTabs.vue?vue&type=template&id=4e25fbb9"
import script from "./ViTeacherAcademicManagementTabs.vue?vue&type=script&lang=js"
export * from "./ViTeacherAcademicManagementTabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports